import {
    MENU_FETCH_SUCCESS
  } from "../types.js";
  
  export const handleMenuAction = data => ({
    type: MENU_FETCH_SUCCESS,
    payload: data
  });